import React, { useContext, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom"
import Details from "./Details";
import Favourites from "./Favourites";
import Home from "./Home";
import PageNotFound from "./PageNotFound";
import Results from "./Results";
import UserLocation from "./UserLocation";
import { UserLocationContext } from "./UserLocation/UserLocationContext";
import { useFiltering } from "./utils/use-filtering";
import FavouritesShared from "./Favourites/FavouritesShared";

export const AppRoutes = () => {
  const location = useLocation();

  useFiltering();

  const { postalCode, postalChecked, promptUserForLocation } = useContext(UserLocationContext);

  useEffect(() => {
    if ((location.pathname.includes("/results") || location.pathname.includes("/favourites") || location.pathname.includes("/details")) && promptUserForLocation && postalChecked && !postalCode?.length) {
      promptUserForLocation("");
    }
  }, [location, postalCode, postalChecked, promptUserForLocation])

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="results" element={<Results />} />
      <Route path="details/:vin" element={<Details />} />
      <Route path="favourites" element={<Favourites />} />
      <Route path="favourites/:ulid" element={<FavouritesShared />} />
      <Route path="404" element={<PageNotFound />} />
      <Route path="*" element={<Navigate to="404" replace />} />
      <Route path="postal" element={<UserLocation />} />
    </Routes>
  );
};
